import { render, staticRenderFns } from "./StoryEditDrawer.vue?vue&type=template&id=467add3c&scoped=true"
import script from "./StoryEditDrawer.vue?vue&type=script&lang=js"
export * from "./StoryEditDrawer.vue?vue&type=script&lang=js"
import style0 from "./StoryEditDrawer.vue?vue&type=style&index=0&id=467add3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467add3c",
  null
  
)

export default component.exports